import { TicketInboxFilter } from "@jugl-web/rest-api/tickets/models/common-types/TicketInboxFilter";
import { ReactNode, useMemo } from "react";
import { ReactComponent as AllIcon } from "./assets/all.svg";
import { ReactComponent as AssignedIcon } from "./assets/assigned.svg";
import { ReactComponent as InProgressIcon } from "./assets/in-progress.svg";
import { ReactComponent as IssuedIcon } from "./assets/issued.svg";
import { ReactComponent as OnCustomerIcon } from "./assets/on-customer.svg";
import { ReactComponent as OnHoldIcon } from "./assets/on-hold.svg";
import { ReactComponent as ResolvedIcon } from "./assets/resolved.svg";
import { ReactComponent as UnassignedIcon } from "./assets/unassigned.svg";

export type TicketsFilterOption = {
  id: TicketInboxFilter;
  /** Short label (mostly used for web). */
  label: string;
  /** Verbose label (mostly used for mobile). */
  verboseLabel: string;
  icon: ReactNode;
};

export const useTicketsFilterOptions = () => {
  const filterOptionById = useMemo<
    Record<TicketInboxFilter, TicketsFilterOption>
  >(
    () => ({
      all: {
        id: "all",
        label: "All",
        verboseLabel: "All Tickets",
        icon: <AllIcon className="shrink-0" />,
      },
      assigned_to_user: {
        id: "assigned_to_user",
        label: "Assigned to me",
        verboseLabel: "Assigned to me",
        icon: <AssignedIcon className="shrink-0" />,
      },
      unassigned: {
        id: "unassigned",
        label: "Unassigned",
        verboseLabel: "Unassigned",
        icon: <UnassignedIcon className="shrink-0" />,
      },
      "todo-today": {
        id: "todo-today",
        label: "To-Do Today",
        verboseLabel: "To-Do Today",
        icon: null,
      },
      recents: {
        id: "recents",
        label: "Recents",
        verboseLabel: "Recents",
        icon: null,
      },
      in_progress: {
        id: "in_progress",
        label: "In Progress",
        verboseLabel: "In Progress",
        icon: <InProgressIcon className="shrink-0" />,
      },
      on_customer: {
        id: "on_customer",
        label: "On Customer",
        verboseLabel: "On Customer",
        icon: <OnCustomerIcon className="shrink-0" />,
      },
      on_hold: {
        id: "on_hold",
        label: "On Hold",
        verboseLabel: "On Hold",
        icon: <OnHoldIcon className="shrink-0" />,
      },
      issued: {
        id: "issued",
        label: "Issued",
        verboseLabel: "Issued",
        icon: <IssuedIcon className="shrink-0" />,
      },
      resolved: {
        id: "resolved",
        label: "Resolved",
        verboseLabel: "Resolved",
        icon: <ResolvedIcon className="shrink-0" />,
      },
    }),
    []
  );

  const filterOptions = useMemo<TicketsFilterOption[]>(
    () => Object.values(filterOptionById),
    [filterOptionById]
  );

  return {
    filterOptionById,
    filterOptions,
  };
};
